import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { selectIsPLGAccount } from "../../../store/userSelectors";
import api from "../../../api";
import ConversationNavItems from "./ConversationNavItems";

class ProfileNavigation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      twilioStatus: false,
      loading: false,
    };
  }

  componentDidMount() {
    this.checkTwilioStatus();
  }

  checkTwilioStatus = async () => {
    try {
      this.setState({ loading: true });
      const { user } = this.props;

      if (!user?.user_id) {
        console.warn("User ID missing for Twilio status check");
        return this.setState({ twilioStatus: false });
      }

      const response = await api.trustHub.checkTwilioStatus(user.user_id);
      this.setState({ twilioStatus: response?.data?.status === true });
    } catch (err) {
      console.error("Error fetching Twilio status:", err);
      this.setState({ twilioStatus: false });
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { location, isPLG } = this.props;
    const { twilioStatus } = this.state;

    return (
      <div className="kt-header__bottom">
        <div className="kt-container" style={{ backgroundColor: "#fff" }}>
          <div
            className="kt-header-menu-wrapper kt-grid__item kt-grid__item--fluid"
            id="kt_header_menu_wrapper"
          >
            <div
              id="kt_header_menu"
              className="kt-header-menu kt-header-menu-mobile "
            >
              <div className="yr-mobpagetitle">Conversations :</div>
              <ul className="kt-menu__nav " style={{ padding: 22 }}>
                <ConversationNavItems
                  user={this.props.user}
                  isPLG={isPLG}
                  location={location}
                  twilioStatus={twilioStatus}
                />
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isPLG: selectIsPLGAccount(state),
});

export default connect(mapStateToProps)(withRouter(ProfileNavigation));
